import { render, staticRenderFns } from "./College.vue?vue&type=template&id=c1163afc&scoped=true&"
import script from "./College.vue?vue&type=script&lang=js&"
export * from "./College.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1163afc",
  null
  
)

export default component.exports